import { BaseEvent } from 'components/common/BigCalendar/types'
import { BaseVirtualEvent } from 'modules/virtualClassrooms/common/types/manager'

export type RoomSettings = {
  maxUsers: number
  name: string
  roomSettingId: Guid
}

export enum VirtualEventScheduleStatus {
  Undefined,
  Open,
  Published,
  Started,
  Ended,
  Cancelled,
}

export type VirtualEventScheduleEvent = BaseEvent & {
  eventId?: string
}

export type BaseVirtualEventSchedule = {
  createdBy: string
  createdDate: DateTime
  endDate: DateTime
  id: Guid
  publishedDate: Nullable<DateTime>
  startDate: DateTime
  status: VirtualEventScheduleStatus
  timeZone: TimeZone
  updatedBy: string
  dateOfChange: DateTime
  roomId: number
  roomSettingId: Guid
}

export type VirtualEventsListSchedule = BaseVirtualEventSchedule & {
  event: BaseVirtualEvent
}

export type VirtualEventScheduleDetails = {
  allowToDownloadRecordings: boolean
  createdBy: string
  createdDate: DateTime
  cstResultId: Nullable<string>
  endDate: DateTime
  eventId: Guid
  startDate: DateTime
  status: VirtualEventScheduleStatus
  timeZone: TimeZone
  updatedBy: string
  updatedDate: DateTime
  utcOffset: string
}
